var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorLengthTextMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4953 11.7411L10.3501 2.85269C10.0466 2.31796 9.4829 2 8.86148 2C8.24006 2 7.69083 2.31796 7.37285 2.85269L2.22767 11.7411C1.92411 12.276 1.92411 12.9118 2.22767 13.4466C2.53123 13.9813 3.09489 14.2993 3.7163 14.2993H14.0067C14.6281 14.2993 15.1773 13.9813 15.4953 13.4466C15.7989 12.9118 15.7989 12.276 15.4953 11.7411ZM14.5414 12.9118C14.498 12.9986 14.3391 13.2153 14.0067 13.2153H3.7163C3.39834 13.2153 3.23936 12.9986 3.18158 12.9118C3.12381 12.8251 3.02259 12.5649 3.18158 12.2904L8.32676 3.41637C8.48574 3.14174 8.76036 3.11281 8.86148 3.11281C8.9627 3.11281 9.23723 3.14174 9.39621 3.41637L14.5414 12.2904C14.7149 12.565 14.5993 12.8107 14.5414 12.9118Z",
    fill: "#890A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83251 10.108C9.13607 10.1224 9.39617 9.89127 9.39617 9.58772L9.54074 6.00343V5.94567C9.52632 5.55542 9.19385 5.26639 8.8181 5.28079C8.42785 5.29521 8.13882 5.62768 8.15323 6.00343L8.29779 9.58771C8.32673 9.86223 8.55789 10.0935 8.83252 10.108L8.83251 10.108Z",
    fill: "#890A0A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64197 11.4232C9.64197 11.8543 9.29255 12.2037 8.86157 12.2037C8.4306 12.2037 8.08118 11.8543 8.08118 11.4232C8.08118 10.9922 8.4306 10.6428 8.86157 10.6428C9.29255 10.6428 9.64197 10.9922 9.64197 11.4232Z",
    fill: "#890A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorLengthTextMessage);
export default __webpack_public_path__ + "static/media/error-length-text-message.b7f3e95f932e71df3f3e4afa82307ec4.svg";
export { ForwardRef as ReactComponent };